import {http, httpFile} from './http_service';
export function loadPageSetting(){
    return http().get('/page-setting');
}